export const getSelectedQuickFilters = (state) =>
  state.quickFilters.selectedFilters.status
